import RecordingNoteComp from "../component/RecordingNoteComp";
import "../AllNotes.css";
import RecordingNoteCompVim from "../component/recordingContainerVim";
import RecordingNoteCompDemo from "../component/RecordingContainerDemo";

const RecordingNoteCont = (props) => {
   const {
      onSave,
      isRecording,
      setIsRecording,
      setShowComponent,
      setIsStartRecording,
      GetNotes,
      createNotes,
      noteId,
      discardRecording,
      showBanner,
      removeRecordingFromUrl,
      uploadMediaV2 = () => {},
      initialTime = "",
      setInitialTime,
      onPermissionNotAllowed,
      patientDetails,
      isVimProvider,
      isDemo = false,
      intitalDemoDone = false,
      setInitialDemo,
   } = props;
   return isDemo ? (
      <RecordingNoteCompDemo
         isDemo={isDemo}
         setInitialDemo={setInitialDemo}
         intitalDemoDone={intitalDemoDone}
         isVimProvider={isVimProvider}
         patientDetails={patientDetails}
         onPermissionNotAllowed={onPermissionNotAllowed}
         setInitialTime={setInitialTime}
         initialTime={initialTime}
         uploadMediaV2={uploadMediaV2}
         removeRecordingFromUrl={removeRecordingFromUrl}
         showBanner={showBanner}
         discardRecording={discardRecording}
         isRecording={isRecording}
         setIsRecording={setIsRecording}
         onStop={(obj) => {
            onSave && onSave(obj);
         }}
         setShowComponent={setShowComponent}
         setIsStartRecording={setIsStartRecording}
         GetNotes={GetNotes}
         createNotes={createNotes}
         noteId={noteId}
      />
   ) : isVimProvider ? (
      <RecordingNoteCompVim
         isDemo={isDemo}
         isVimProvider={isVimProvider}
         patientDetails={patientDetails}
         onPermissionNotAllowed={onPermissionNotAllowed}
         setInitialTime={setInitialTime}
         initialTime={initialTime}
         uploadMediaV2={uploadMediaV2}
         removeRecordingFromUrl={removeRecordingFromUrl}
         showBanner={showBanner}
         discardRecording={discardRecording}
         isRecording={isRecording}
         setIsRecording={setIsRecording}
         onStop={(obj) => {
            onSave && onSave(obj);
         }}
         setShowComponent={setShowComponent}
         setIsStartRecording={setIsStartRecording}
         GetNotes={GetNotes}
         createNotes={createNotes}
         noteId={noteId}
      />
   ) : (
      <RecordingNoteComp
         isVimProvider={isVimProvider}
         patientDetails={patientDetails}
         onPermissionNotAllowed={onPermissionNotAllowed}
         setInitialTime={setInitialTime}
         initialTime={initialTime}
         uploadMediaV2={uploadMediaV2}
         removeRecordingFromUrl={removeRecordingFromUrl}
         showBanner={showBanner}
         discardRecording={discardRecording}
         isRecording={isRecording}
         setIsRecording={setIsRecording}
         onStop={(obj) => {
            onSave && onSave(obj);
         }}
         setShowComponent={setShowComponent}
         setIsStartRecording={setIsStartRecording}
         GetNotes={GetNotes}
         createNotes={createNotes}
         noteId={noteId}
      />
   );
};

export default RecordingNoteCont;
